import Penalty from "./penalty";

export default class KickOffPenalty extends Penalty {}
